var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('miniweb-template-basic',{attrs:{"data-template":_vm.data}}),_c('miniweb-template-elegant',{attrs:{"data-template":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }